import React from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';

const TransparencyPolicy = () => {
  return (
    <div className="pt-20" data-testid="transparency-page">
      {/* Hero Section */}
      <section className="py-16 md:py-20 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <Eye className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold">
              Donation Transparency Policy
            </h1>
            <p className="mt-4 text-slate-300">Lane 4 For All Kids Foundation</p>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate prose-lg">
          <p className="text-slate-600"><strong>Effective Date:</strong> January 2026</p>

          <p><strong>Lane 4 For All Kids Foundation</strong> is committed to transparency, accountability, and responsible stewardship of all donations received. We value the trust placed in us by our supporters and strive to ensure that all contributions are used effectively to support our mission.</p>

          <h2 className="font-heading">How Donations Are Used</h2>
          <p>Donations to Lane 4 For All Kids Foundation support programs that expand access to youth athletics and reduce financial barriers for young athletes. Funds may be used to support:</p>
          <ul>
            <li>Youth athlete sponsorships</li>
            <li>Athletic equipment and gear</li>
            <li>Backpack and supply drives</li>
            <li>Travel assistance for competitions</li>
            <li>Community events and youth programs</li>
            <li>Operational expenses necessary to run and grow the organization</li>
          </ul>
          <p>We work to ensure that funds are used responsibly and in alignment with our mission.</p>

          <h2 className="font-heading">Financial Oversight</h2>
          <p>Lane 4 For All Kids Foundation maintains financial oversight practices designed to ensure transparency and accountability. Financial records are maintained and reviewed to ensure responsible management of funds. As the organization grows and obtains federal tax-exempt status, financial reporting may include additional disclosures in accordance with nonprofit standards.</p>

          <h2 className="font-heading">Donor Privacy</h2>
          <p>Lane 4 For All Kids Foundation respects donor privacy. We do not sell, trade, or share donor information with outside organizations. Donor information is used only for purposes related to processing donations, providing receipts, and communicating updates about our programs and impact.</p>

          <h2 className="font-heading">Tax Status</h2>
          <p>Lane 4 For All Kids Foundation is currently in the process of obtaining 501(c)(3) tax-exempt status from the Internal Revenue Service. Until approval is granted, donations may not be tax-deductible. If tax-exempt status is approved, donations may become deductible to the extent permitted by law.</p>

          <h2 className="font-heading">Contact Us</h2>
          <p>If you have questions about how donations are used, please contact:</p>
          <p>
            <strong>Lane 4 For All Kids Foundation</strong><br />
            Email: info@lane4foundation.com<br />
            Phone: 877.495.2634
          </p>
        </div>
      </section>
    </div>
  );
};

export default TransparencyPolicy;
